import { Checkbox, FormControl, FormControlLabel } from '@mui/material';
import { FormikProps } from 'formik';
import React from 'react';
import { v4 } from 'uuid';
import * as Yup from 'yup';

import { FormBodyAPI } from 'src/constants/fieldsTypes';

interface FormValues {
  label: string;
  value: string;
}

/**
 * Client signing form for a Checkbox field. Mirrors the Text/Date client forms
 * and is rendered by SignatureClientFormV2 so the CU's path to "commit + advance"
 * is the same single Insert/Skip button used by every other field type.
 */
export const useAddCheckboxClientForm = () => {
  const validationScheme = Yup.object().shape({
    value: Yup.string().oneOf(['true', 'false']).required(),
  });

  const getSubmitValues = () => Promise.resolve({ key: v4() });

  const FormRenderer: React.FC<FormBodyAPI<FormValues>> = (props) => {
    const { values, setFieldValue } = props as FormikProps<FormValues>;
    const checked = values.value === 'true';

    return (
      <FormControl fullWidth>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={() =>
                setFieldValue('value', checked ? 'false' : 'true')
              }
              color="primary"
              inputProps={{
                'aria-label': values.label || 'Checkbox',
              }}
            />
          }
          // Empty label renders just the Checkbox — the panel title above
          // already provides context, so an unlabelled box reads cleanly.
          label={values.label || ''}
        />
      </FormControl>
    );
  };

  return { validationScheme, getSubmitValues, FormRenderer };
};
